import { ClipboardList } from 'lucide-react';
import {
	getProntuarioTherapeuticPlanVisibleFields,
	type ProntuarioTherapeuticPlanRecord,
} from '../types/prontuarioTherapeuticPlan';
import { ProntuarioProfileFieldList } from './prontuario/ProntuarioProfileFieldList';
import { ProntuarioProfileEmptyState } from './prontuario/ProntuarioProfileEmptyState';
import { ProntuarioReadonlyField } from './SessionCallProntuarioFields';

type SessionCallProntuarioPlanoTerapeuticoTabProps = {
	plan?: ProntuarioTherapeuticPlanRecord | null;
	variant?: 'default' | 'profile';
	profileTheme?: 'dark' | 'light';
};

const SessionCallProntuarioPlanoTerapeuticoTab = ({
	plan = null,
	variant = 'default',
	profileTheme = 'dark',
}: SessionCallProntuarioPlanoTerapeuticoTabProps) => {
	const visibleFields = plan
		? getProntuarioTherapeuticPlanVisibleFields(plan)
		: [];

	if (visibleFields.length === 0) {
		return (
			<ProntuarioProfileEmptyState
				variant={profileTheme}
				title="Nenhum plano terapêutico registrado"
				description="O plano terapêutico do participante será exibido aqui quando houver registros."
				icon={
					<ClipboardList
						className="size-5 shrink-0"
						strokeWidth={2}
					/>
				}
			/>
		);
	}

	if (variant === 'profile') {
		return (
			<ProntuarioProfileFieldList
				variant={profileTheme}
				fields={visibleFields.map(({ key, label, fullWidth }) => ({
					label,
					value: plan![key]!.trim(),
					multiline: fullWidth,
				}))}
			/>
		);
	}

	return (
		<div className="grid grid-cols-1 gap-3.5 sm:grid-cols-2">
			{visibleFields.map(({ key, label, fullWidth }) => (
				<ProntuarioReadonlyField
					key={key}
					label={label}
					value={plan![key]!.trim()}
					fullWidth={fullWidth}
					appearance="material"
				/>
			))}
		</div>
	);
};

export { SessionCallProntuarioPlanoTerapeuticoTab };
